<template>
  <div class="menu-list" flex>
    <router-link :to="{ name: 'mypage' }" class="menu">{{
      $t("mypage.menu[0]")
    }}</router-link>
    <router-link :to="{ name: 'confirm' }" class="menu">{{
      $t("mypage.menu[1]")
    }}</router-link>
    <router-link :to="{ name: 'authAddress' }" class="menu">{{
      "주소록관리"
    }}</router-link>
  </div>
</template>

<script>
export default {};
</script>

<style scoped lang="scss">
@import "/src/styles/import.scss";

div {
  box-sizing: border-box;
}
.menu-list {
  display: flex;
  flex-direction: row;
  justify-content: stretch;
  position: relative;
  border-bottom: 2px solid $white-color;
  /* padding: 0px 12px; */
  .menu {
    flex: 1;
    position: relative;
    bottom: -1px;
    /* width: 50%; */
    font-size: 15px;
    padding: 16px 0;
    font-size: 16px;
    /* font-weight: bold; */
    text-align: center;
    color: #b4b4b4;
    // color: $main-color;
    &.router-link-active {
      color: $main-color;
      border-bottom: 2px solid $main-color;
    }
  }
}
</style>
